import React from 'react';
import SectionTitle from '../Typography/SectionTitle';
import { IconName } from '../SVGIcon/SVGIcon.types';

export const LayoutSection = ({
  children,
  className,
  title,
  description,
  id,
  icon,
}: {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  id?: string;
  icon?: IconName;
}) => {
  return (
    // pt-[10px]
    <section className={`mt-[60px] lg:mt-[100px] bg-white  ${className}`} id={id}>
      {title && description && (
        <SectionTitle
          title={title}
          description={description}
          icon={icon}
          bgWhite={true}
        />
      )}
      <div className={`px-4 md:px-[24px] lg:px-[24px] 2xl:px-[48px] ${className}`}>
        <div className="ml-0 max-w-[1268px]">{children}</div>
      </div>
    </section>
  );
};
